export default __webpack_public_path__ + "static/media/agreement.26f5f9fb.pdf";